export default __webpack_public_path__ + "static/google reviews logo-e07a6e144cc1f663a393eb8ccd03ba4b.svg";